import * as React from 'react'

import { useClientBonusAccountEdit } from './hooks'
import {
  CCard,
  CCardBody,
  CCol,
  CNav,
  CNavItem,
  CNavLink,
  CRow,
  CTabContent,
  CTabPane,
} from '@coreui/react-pro'
import { useState } from 'react'
import { ClientBonusAccount } from './types'

type Props = {
  className?: string
}

export const ClientBonusAccountEdit = ({ className }: Props) => {
  const clientBonusAccount = useClientBonusAccountEdit()
  const [activeBonusAccountTab, setActiveBonusAccountTab] = useState(1)

  return (
    <div>
      <ClientBonusAccountDetail
        className={className}
        account={clientBonusAccount}
      ></ClientBonusAccountDetail>
    </div>
  )
}

type BonusAccountDetailProps = {
  className?: string
  account: ClientBonusAccount
}

const ClientBonusAccountDetail = ({
  className,
  account,
}: BonusAccountDetailProps) => {
  return (
    <CCol xs={12} className={className}>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol>
              <p>MT Login: {account.login}</p>
              <p>Status: {account.status}</p>
              <p>Open: {account.accountOpenedAt}</p>
              <p>Close: {account.accountClosingAt}</p>
              <p>Balance: {account.balance}</p>
              <p>Profit: {account.profit}</p>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  )
}

type BalanceOperationsProps = {
  className?: string
  account: ClientBonusAccount
}

const BonusAccountBalanceOperations = ({
  className,
  account,
}: BalanceOperationsProps) => {
  return (
    <CCol xs={12} className={className}>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol>
              <a
                target="_blank"
                href="https://h2o-team.atlassian.net/wiki/spaces/HEADLINER/pages/13795331/HWS+CRM+Clients#2.2.2.1.-%D0%91%D0%B0%D0%BB%D0%B0%D0%BD%D1%81%D0%BE%D0%B2%D1%8B%D0%B5-%D0%BE%D0%BF%D0%B5%D1%80%D0%B0%D1%86%D0%B8%D0%B8"
              >
                HWS CRM: Clients 2.2.2.1. Балансовые операции
              </a>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  )
}
type TradingOperationsProps = {
  className?: string
  account: ClientBonusAccount
}

const BonusAccountTradingOperations = ({
  className,
  account,
}: TradingOperationsProps) => {
  return (
    <CCol xs={12} className={className}>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol>
              <a
                target="_blank"
                href="https://h2o-team.atlassian.net/wiki/spaces/HEADLINER/pages/13795331/HWS+CRM+Clients#2.2.2.2.-%D0%A2%D0%BE%D1%80%D0%B3%D0%BE%D0%B2%D1%8B%D0%B5-%D0%BE%D0%BF%D0%B5%D1%80%D0%B0%D1%86%D0%B8%D0%B8"
              >
                HWS CRM: Clients 2.2.2.2. Торговые операции
              </a>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  )
}
